import { Col, Row } from "antd";
import { get } from "lodash";
import { useTranslation } from "react-i18next";
import { MdOutlineSchool } from "react-icons/md";
import Button from "shared/components/Button";
import Form from "shared/components/Form";
import Input from "shared/components/Input";
import Label from "shared/components/Label";
import { NAME_SPACES } from "shared/locales/constants";
import { RELATIONSHIP } from "utils/constants";
import { getAgeFromBirthDate } from "screens/Private/Broker/Projects/Detail/Templates/Comparison/Acoris/utils/relatedPersonChild";

const CHILD_ID_AGE_THRESHOLD = 18;

const StudentCertificate = ({
  values,
  onFileRemove,
  setFieldValue,
  setPercent,
  subscription,
}) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.CONTRACT);
  const SUBSCRIPTION = t("SUBSCRIPTION", { returnObjects: true });

  const relatedPersons = get(
    subscription,
    "project.contact.relatedPersons",
    [],
  ).filter(Boolean);

  const adultChildren = relatedPersons.filter(
    (person) =>
      person?.relationship === RELATIONSHIP.CHILD &&
      getAgeFromBirthDate(get(person, "identity.user.birthDate")) >=
        CHILD_ID_AGE_THRESHOLD,
  );

  if (!adultChildren.length) return null;

  return (
    <div className="subscription-form--wrapper">
      <Form
        type="vertical"
        title={SUBSCRIPTION.FORM.PROOF.STUDENT_CERTIFICATE?.TITLE}
        subtitle={SUBSCRIPTION.FORM.PROOF.STUDENT_CERTIFICATE?.SUBTITLE}
      >
        {adultChildren.map((child, index) => {
          const userId = get(child, "identity.user.id");
          const firstName = get(child, "identity.user.firstname", "");
          const lastName = get(child, "identity.user.lastname", "");
          const childName = [firstName, lastName].filter(Boolean).join(" ");
          const fieldKey = userId
            ? `childStudentCertificate_${userId}`
            : `childStudentCertificate_${index}`;

          return (
            <Row gutter={[16, 16]} key={userId || index}>
              <Col lg={24} xs={24}>
                <div className="subscription-form--group-label">
                  <Label
                    label={
                      childName ||
                      SUBSCRIPTION.FORM.PROOF.STUDENT_CERTIFICATE?.LABEL
                    }
                    icon={<MdOutlineSchool size={16} />}
                    required
                  />
                </div>
              </Col>
              <Col lg={24} xs={24}>
                <div className="subscription-form--custom-upload">
                  <Input
                    type="file"
                    variant="uploader"
                    validTypes={SUBSCRIPTION.FORM.PROOF.ALLOWED_FILES_TYPE}
                    multiple
                    onUpload={(fileList) => {
                      setFieldValue(`proof.${fieldKey}`, fileList);
                      setPercent({
                        ...values,
                        proof: { ...values.proof, [fieldKey]: fileList },
                      });
                    }}
                    onFileRemove={onFileRemove}
                    fileList={get(values, `proof.${fieldKey}`, [])}
                  >
                    <Row align="center">
                      <Button type="primary--link">
                        {SUBSCRIPTION.FORM.PROOF.ACTION.ADD}
                      </Button>
                    </Row>
                  </Input>
                </div>
              </Col>
            </Row>
          );
        })}
      </Form>
    </div>
  );
};

export default StudentCertificate;
